import React, { useEffect, useState } from 'react'
import propTypes from "prop-types"
import { Strings } from "../../assets/res/en"
import { TextField, MenuItem, InputAdornment, IconButton } from '@material-ui/core'
import { MuiPickersUtilsProvider, DatePicker, DateTimePicker } from '@material-ui/pickers'
import { CalendarToday } from '@material-ui/icons'
import DateFnsUtils from '@date-io/date-fns'
import MaskedInput from "react-text-mask"
function CardMaskInput(props) {
  const { inputRef, ...other } = props;

  return (
    <MaskedInput
      {...other}
      ref={(ref) => {
        inputRef(ref ? ref.inputElement : null);
      }}
      mask={[/\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/]}
      keepCharPositions
      guide
      placeholderChar='X'
      placeholder="XXXX-XXXX-XXXX-XXXX"
    />
  );
}

CardMaskInput.propTypes = {
  inputRef: propTypes.func.isRequired,
};

function SearchBox(props) {
  const { name, defaultValue, fullWidth, variant, label, type, isSelect, menuItems, isMaskedInput, onChange, size, isDisable, minDate } = props
  const [value, setValue] = useState(defaultValue ?? '')
  const [selectedOption, setselectedOption] = useState(defaultValue)
  const [selectedDate, setSelectedDate] = useState(defaultValue)
  useEffect(() => {
    if (menuItems && menuItems.length <= 1)
      setselectedOption(defaultValue)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [menuItems])
  useEffect(() => {
    if (isSelect)
      setselectedOption(defaultValue)
    else if (['date', 'datetime'].includes(type.toLowerCase()))
      setSelectedDate(defaultValue)
    else
      setValue(defaultValue)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [defaultValue])
  const handleDateChange = (date) => {
    setSelectedDate(date)
    onChange(name, date)
  }
  const handleSelectionChange = (event) => {
    const { value } = event.target
    setselectedOption(value)
    onChange(name, value, selectedOption)
  }
  const handleChange = (event) => {
    const { value } = event.target
    setValue(value)
    const actualValue = value.replaceAll('-', '').replaceAll('X', '')

    onChange(name, actualValue)
  }
  return (
    <>
      {
        isSelect ?
          <TextField
            name={name}
            fullWidth={fullWidth}
            size={size}
            variant={variant}
            label={label}
            type={type}
            select={isSelect}
            SelectProps={{ defaultValue: defaultValue }}
            value={selectedOption}
            disabled={isDisable}
            onChange={handleSelectionChange}>
            {menuItems.map(item => <MenuItem key={`${item.val}_${item.text}`} value={item.val}>{item.text}</MenuItem>)}
          </TextField> :
          type === 'date' ?
            <MuiPickersUtilsProvider utils={DateFnsUtils}>
              <DatePicker
                name={name}
                fullWidth={fullWidth}
                size={size}
                inputVariant={variant}
                label={label}
                clearable
                format="MM/dd/yyyy"
                value={selectedDate}
                disabled={isDisable}
                minDate={minDate}
                onChange={handleDateChange}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton size="small">
                        <CalendarToday fontSize="small" />
                      </IconButton>
                    </InputAdornment>
                  )
                }}
              />
            </MuiPickersUtilsProvider> :
            type === 'datetime' ?
              <MuiPickersUtilsProvider utils={DateFnsUtils}>
                <DateTimePicker
                  name={name}
                  fullWidth={fullWidth}
                  size={size}
                  inputVariant={variant}
                  label={label}
                  clearable
                  format="MM/dd/yyyy hh:mm a"
                  value={selectedDate}
                  disabled={isDisable}
                  minDate={minDate}
                  onChange={handleDateChange}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton size="small">
                          <CalendarToday fontSize="small" />
                        </IconButton>
                      </InputAdornment>
                    )
                  }}
                />
              </MuiPickersUtilsProvider> :
              isMaskedInput ?
                <TextField
                  name={name}
                  fullWidth={fullWidth}
                  size={size}
                  variant={variant}
                  label={label}
                  type={type}
                  value={value}
                  onChange={handleChange}
                  disabled={isDisable}
                  InputProps={{
                    inputComponent: CardMaskInput,
                  }}
                /> :
                <TextField
                  name={name}
                  fullWidth={fullWidth}
                  size={size}
                  variant={variant}
                  label={label}
                  type={type}
                  value={value}
                  disabled={isDisable}
                  onChange={handleChange} />
      }
    </>
  )
}
SearchBox.defaultProps = {
  name: "",
  defaultValue: '',
  size: 'small',
  fullWidth: true,
  variant: "outlined",
  label: Strings.SEARCH,
  menuItems: [],
  type: "",
  isSelect: false,
  isDisable: false,
  isMaskedInput: false,
  minDate: null,
  onChange: function () { }
}
SearchBox.propTypes = {
  name: propTypes.string,
  defaultValue: propTypes.any,
  fullWidth: propTypes.bool,
  variant: propTypes.oneOf(["standard", "outlined", "filled"]),
  label: propTypes.string,
  menuItems: propTypes.array,
  type: propTypes.oneOf(['search', 'number', 'select', 'date', 'datetime', '']),
  isSelect: propTypes.bool,
  isDisable: propTypes.bool,
  isMaskedInput: propTypes.bool,
  minDate: propTypes.any,
  onChange: propTypes.func
}

export { SearchBox }